import React, { useState, useEffect } from "react";
import { Text } from "components";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import { AgGridReact } from "ag-grid-react"; // React Grid Logic
import "ag-grid-community/styles/ag-grid.css"; // Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import AccessRightCard from "pages/AccessRight/AccessRightCard";
// import { width } from "pdfkit/js/page";
pdfMake.vfs = pdfFonts.pdfMake?.vfs;

const RevenueSummaryReport = () => {
  const [hospitalBuissnessSummaryReport, setHospitalBuissnessSummaryReport] =
    useState([]);
  const [
    hospitalBuissnessFeeDistributionSummaryReport,
    setHospitalBuissnessFeeDistributionSummaryReport,
  ] = useState([]);
  const [
    hospitalBuissnessPaymentTypeSummaryReport,
    setHospitalBuissnessPaymentTypeSummaryReport,
  ] = useState([]);
  const [filterAppointment, setFilterAppointment] = useState([]);
  const [pdfexportflag, setpdfexportflag] = useState(false);
  const [repotType, setReportType] = useState([
    { id: 1, name: "Business Summary Report" },
    { id: 2, name: "Bill Item-wise Business Summary Report" },
    { id: 3, name: "Payment Mode-wise Business summary Report" },
  ]);
  const [reportTypeId, setReportTypeId] = useState();
  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const [doclist, setdoclist] = useState([]);
  useEffect(() => {
    // Retrieving data from sessionStorage
    const storeddoclist = sessionStorage.getItem("docAccesslist");

    if (storeddoclist) {
      try {
        // Parsing the JSON string to an array of objects
        const parseddoclist = JSON.parse(storeddoclist);
        setdoclist(parseddoclist);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, []);
  const showActionColumn = doclist.some(
    (item) => item.hospital_module_id == 24 && item.view,
  );

  const validationSchema = Yup.object().shape({
    from_date: Yup.string().required("Start Date is required"),
    to_date: Yup.date()
      .required("End Date is required")
      .max(new Date(), "End Date cannot be in the future"),
    report_type_id: Yup.string().required("Report Type is required"),
  });
  // for initializing the start date and end date
  const today = new Date();
  const firstDay = new Date(today.getFullYear(), today.getMonth(), 2);
  const formatDate = (date) => date.toISOString().split("T")[0];
  const formik = useFormik({
    initialValues: {
      from_date: formatDate(firstDay),
      to_date: formatDate(today),
      report_type_id: "",
    },
    validationSchema: validationSchema,
  });

  useEffect(() => {
    if (reportTypeId == 1) {
      getHospitalBuissnessSummaryReport();
    } else if (reportTypeId == 2) {
      getHospitalBuissnessFeeDistributionSummaryReport();
    } else if (reportTypeId == 3) {
      getHospitalBuissnessPaymentTypeSummaryReport();
    }
  }, []);

  // for reportTypeId=1

  const getHospitalBuissnessSummaryReport = (from_date, to_date) => {
    if (from_date != "" && to_date != "") {
      axios
        .post(
          "/api/doctor/report/hospital/buissness/summary/get",
          { from_date: from_date, to_date: to_date },
          headers,
        )
        .then((response) => {
          setHospitalBuissnessSummaryReport(response.data);
          console.log(response.data);
        })
        .catch(() => {
          console.log("Error");
        });
    }
  };

  //for Report Type Id =2
  const getHospitalBuissnessFeeDistributionSummaryReport = (
    from_date,
    to_date,
  ) => {
    if (from_date != "" && to_date != "") {
      axios
        .post(
          "/api/doctor/report/hospital/fee_distribution/buissness/summary/get",
          { from_date: from_date, to_date: to_date },
          headers,
        )
        .then((response) => {
          setHospitalBuissnessFeeDistributionSummaryReport(response.data);
          console.log(response.data);
        })
        .catch(() => {
          console.log("Error");
        });
    }
  };

  //FOR REPORTTYPEID==3
  const getHospitalBuissnessPaymentTypeSummaryReport = (from_date, to_date) => {
    if (from_date != "" && to_date != "") {
      axios
        .post(
          "/api/doctor/report/hospital/payment_type/buissness/summary/get",
          { from_date: from_date, to_date: to_date },
          headers,
        )
        .then((response) => {
          setHospitalBuissnessPaymentTypeSummaryReport(response.data);
          console.log(response.data);
        })
        .catch(() => {
          console.log("Error");
        });
    }
  };

  //for reporttypeid=3

  //for reporttypeid=1

  const [colDefsForReportId1, setcolDefsForReportId1] = useState([
    { headerName: "Sr.No.", field: "sr", width: 85, minWidth: 75, },
    {
      headerName: "FROM DATE",
      field: "from_date",
      minWidth: 100,
    },
    {
      headerName: "TO DATE",
      field: "to_date",
      minWidth: 100,

    },
    {
      headerName: "TOTAL AMOUNT (Rs)",
      field: "total_fee",
      minWidth: 120,
      flex: 1,
    },
    {
      headerName: "TOTAL RECEIVED (Rs)",
      field: "received_fee",
      minWidth: 120,
      flex: 1,
    },
    {
      headerName: "TOTAL PENDING (Rs)",
      field: "pending_fee",
      width: 150,
      minWidth: 170,
      pinned: "right"
    },
  ]);

  //for report type id =2
  const [colDefsForReportId2, setcolDefsForReportId2] = useState([
    { headerName: "SNO.", field: "sr", width: 85, minWidth: 75, },
    {
      headerName: "PROCEDURE NAME",
      field: "fee_type_name",
      minWidth: 150,
      flex: 1,
    },
    {
      headerName: "FROM DATE",
      field: "from_date",
      minWidth: 100,
    },
    {
      headerName: "TO DATE",
      field: "to_date",
      minWidth: 100,
    },
    {
      headerName: "TOTAL AMOUNT (Rs)",
      field: "total_fee",
      width: 150,
      minWidth: 170,
      pinned: "right",
    },
  ]);

  //for reportTypeId ==3

  const [colDefsForReportId3, setcolDefsForReportId3] = useState([
    { headerName: "SNO.", field: "sr", width: 85, minWidth: 75, },
    {
      headerName: "PAYMENT NAME",
      field: "payment_type_name",
      minWidth: 150,
      flex: 1,
    },
    {
      headerName: "FROM DATE",
      field: "from_date",
      minWidth: 100,
    },
    {
      headerName: "TO DATE",
      field: "to_date",
      minWidth: 100,
    },
    {
      headerName: "TOTAL AMOUNT (Rs)",
      field: "total_fee",
      minWidth: 150,
      width: 170,
      pinned: "right",
    },
  ]);

  function getBase64ImageFromURL(url) {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute("crossOrigin", "anonymous");

      img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        var dataURL = canvas.toDataURL("image/png");

        resolve(dataURL);
      };

      img.onerror = (error) => {
        reject(error);
      };

      img.src = url;
    });
  }

  //report Type id ==2
  const DownloadPDF2 = async () => {
    let totalSum = 0;
    for (
      let i = 0;
      i < hospitalBuissnessFeeDistributionSummaryReport.length;
      i++
    ) {
      totalSum += hospitalBuissnessFeeDistributionSummaryReport[i].total_fee;
    }

    const docDefinition = {
      pageOrientation: "portrait",
      header: {},
      content: [
        { text: "", margin: [0, 10] },

        {
          text: "Bill Item-Wise Business Summary Report",
          margin: [0, 10],
          alignment: "center",
        },
        {
          canvas: [
            { type: "line", x1: 0, y1: 0, x2: 500.28, y2: 0, lineWidth: 0.5 },
          ],
        },
        { text: "", margin: [0, 5] },
        {
          style: "tableExample",
          table: {
            widths: [240, 245],
            body: [
              [
                {
                  text: `From Date : ${hospitalBuissnessFeeDistributionSummaryReport[0].from_date}`,
                  style: "tableHeader",
                },
                {
                  text: `To Date : ${hospitalBuissnessFeeDistributionSummaryReport[0].to_date}`,
                  style: "tableHeader",
                },
              ],
            ],
          },
        },
        { text: "", margin: [0, 5] },
        {
          style: "tableExample",
          table: {
            widths: [150, 100, 110, 110],
            body: [
              [
                { text: "Procedure Name", style: "tableHeader" },
                { text: "From Date", style: "tableHeader" },
                { text: "To Date", style: "tableHeader" },
                { text: "Total Amount(Rs.)", style: "tableHeader" },
              ],
              ...hospitalBuissnessFeeDistributionSummaryReport.map((report) => [
                report.fee_type_name,
                report.from_date,
                report.to_date,
                report.total_fee,
              ]),
              [
                {
                  text: "Total",
                  style: "tableHeader",
                  colSpan: 3,
                  alignment: "right",
                },
                {},
                {},
                { text: totalSum, style: "tableHeader", alignment: "left" },
              ],
            ],
          },
          layout: {
            fillColor: (rowIndex) => (rowIndex === 0 ? "#CCCCCC" : null),
          },
        },
      ],
      styles: {
        tableExample: {
          fontSize: 8,
        },
        tableHeader: {
          bold: true,
          fontSize: 10,
        },
        header: {
          fontSize: 18,
          bold: true,
          margin: [10, 10, 10, 20],
        },
      },
    };
    pdfMake
      .createPdf(docDefinition)
      .download("Bill Item-wise Business Summary Report");
  };

  // const DownloadPDF3 = () => {
  //   let totalSum = 0;
  //   for (let i = 0; i < hospitalBuissnessPaymentTypeSummaryReport.length; i++) {
  //     totalSum = totalSum + hospitalBuissnessPaymentTypeSummaryReport[i].total_fee
  //   }

  //   const docDefinition = {
  //     pageOrientation: "portrait",

  //     content: [
  //       {
  //         image: await getBase64ImageFromURL("images/img_aurindamjpeg.png"),
  //         fit:[100,100],
  //         alignment: "center"

  //       },
  //       { text: "", margin: [0, 10] },
  //       {// Add the line here
  //         canvas: [{ type: "line", x1: 0, y1: 0, x2: 500.28, y2: 0, lineWidth: 0.5 }],
  //       },
  //       { text: "Payment Mode-Wise Business Summary Report", margin: [0, 10], alignment: 'center' },
  //       {// Add the line here
  //         canvas: [{ type: "line", x1: 0, y1: 0, x2: 500.28, y2: 0, lineWidth: 0.5 }],
  //       },
  //       { text: "", margin: [0, 5] },
  //       {
  //         style: "tableExample",
  //         table: {
  //           widths: [235, 235], // Set widths for each column
  //           body: [
  //             [

  //               [{ text: `From Date : ${hospitalBuissnessPaymentTypeSummaryReport[0].from_date} `, style: "tableHeader" }],
  //               [{ text: `To Date :  ${hospitalBuissnessPaymentTypeSummaryReport[0].to_date}`, style: "tableHeader" }],
  //             ],
  //           ],
  //         },
  //       },
  //       { text: "", margin: [0, 5] },
  //       {
  //         style: "tableExample",
  //         table: {
  //           widths: [150, 100, 100, 100], // Set widths for each column
  //           body: [
  //             [
  //               [{ text: "Payment Name", style: "tableHeader" }],
  //               [{ text: "From Date", style: "tableHeader" }],
  //               [{ text: "To Date", style: "tableHeader" }],
  //               [{ text: "Total Amount(Rs.)", style: "tableHeader" }],
  //             ],
  //             ...hospitalBuissnessPaymentTypeSummaryReport.map((hospitalBuissnessPaymentTypeSummaryReport, index) => [
  //               hospitalBuissnessPaymentTypeSummaryReport.payment_type_name,
  //               hospitalBuissnessPaymentTypeSummaryReport.from_date,
  //               hospitalBuissnessPaymentTypeSummaryReport.to_date,
  //               hospitalBuissnessPaymentTypeSummaryReport.total_fee,
  //             ]),
  //             //for total
  //             [
  //               { text: "Total", style: "tableHeader", colSpan: 3, alignment: "right" },
  //               {},
  //               {},
  //               { text: totalSum, style: "tableHeader", alignment: "left" }
  //             ]
  //           ],
  //         },
  //         layout: {
  //           fillColor: function (rowIndex, node, columnIndex) {
  //             return rowIndex === 0 ? "#CCCCCC" : null;
  //           },
  //         },
  //       },
  //     ],
  //     styles: {
  //       tableExample: {
  //         fontSize: 8, // Set the font size to a smaller value
  //       },
  //       tableHeader: {
  //         bold: true,
  //         fontSize: 10, // You can set a different font size for headers if needed
  //       },
  //       header: {
  //         fontSize: 18,
  //         bold: true,
  //         margin: [10, 10, 10, 20],
  //       },
  //     },
  //   };
  //   pdfMake.createPdf(docDefinition).download("Bill Item-wise Business Summary Report");
  // };

  const DownloadPDF3 = async () => {
    let totalSum = 0;
    for (let i = 0; i < hospitalBuissnessPaymentTypeSummaryReport.length; i++) {
      totalSum += hospitalBuissnessPaymentTypeSummaryReport[i].total_fee;
    }
    const docDefinition = {
      pageOrientation: "portrait",
      content: [
        { text: "", margin: [0, 10] },

        {
          text: "Payment Mode-Wise Business Summary Report",
          margin: [0, 10],
          alignment: "center",
        },
        {
          canvas: [
            { type: "line", x1: 0, y1: 0, x2: 500.28, y2: 0, lineWidth: 0.5 },
          ],
        },
        { text: "", margin: [0, 5] },
        {
          style: "tableExample",
          table: {
            widths: [240, 245],
            body: [
              [
                {
                  text: `From Date : ${hospitalBuissnessPaymentTypeSummaryReport[0].from_date}`,
                  style: "tableHeader",
                },
                {
                  text: `To Date : ${hospitalBuissnessPaymentTypeSummaryReport[0].to_date}`,
                  style: "tableHeader",
                },
              ],
            ],
          },
        },
        { text: "", margin: [0, 5] },
        {
          style: "tableExample",
          table: {
            widths: [150, 100, 110, 110],
            body: [
              [
                { text: "Payment Name", style: "tableHeader" },
                { text: "From Date", style: "tableHeader" },
                { text: "To Date", style: "tableHeader" },
                { text: "Total Amount(Rs.)", style: "tableHeader" },
              ],
              ...hospitalBuissnessPaymentTypeSummaryReport.map((report) => [
                report.payment_type_name,
                report.from_date,
                report.to_date,
                report.total_fee,
              ]),
              [
                {
                  text: "Total",
                  style: "tableHeader",
                  colSpan: 3,
                  alignment: "right",
                },
                {},
                {},
                { text: totalSum, style: "tableHeader", alignment: "left" },
              ],
            ],
          },
          layout: {
            fillColor: (rowIndex) => (rowIndex === 0 ? "#CCCCCC" : null),
          },
        },
      ],
      styles: {
        tableExample: {
          fontSize: 8,
        },
        tableHeader: {
          bold: true,
          fontSize: 10,
        },
        header: {
          fontSize: 18,
          bold: true,
          margin: [10, 10, 10, 20],
        },
      },
    };
    pdfMake
      .createPdf(docDefinition)
      .download("Bill Item-wise Business Summary Report");
  };

  const ColDefaultVale = { filter: true };
  const gridOptions = {
    overlayNoRowsTemplate: `
        <div id="progress-bar-id" class="flex items-center justify-center">
            <div class="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500"></div>
        </div>
    `,
  };
  const gridOptions2 = {
    overlayNoRowsTemplate: `
      <div id="progress-bar-id" class="flex items-center justify-center" style="font-size: 20px; padding: 20px;">
        <div>
          <p>No Data Found</p>
        </div>
      </div>
    `,
  };
  return (
    <>
      {showActionColumn ? (
        <div className="overflow-hidden">
          <form onSubmit={formik.handleSubmit}>
            <div className="rounded-md justify-center  ">
              <div className="filter-section">
                {/* start date */}
                <div >
                  <div className="filter-section-label">
                    <span >
                      Start Date
                    </span>
                    <span className="text-red-500 ">
                      *
                    </span>
                  </div>
                  <input
                    name="from_date"
                    type="date"
                    placeholder="Enter start date"
                    value={formik.values.from_date}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className="filter-section-input"
                  ></input>
                  {formik.touched.from_date && formik.errors.from_date ? (
                    <div className="form-error ">
                      {formik.errors.from_date}
                    </div>
                  ) : null}
                </div>
                {/* end date */}
                <div >
                  <Text
                    className="filter-section-label"
                  >
                    <span>
                      End Date
                    </span>
                    <span className="text-red-500">
                      *
                    </span>
                  </Text>
                  <input
                    name="to_date"
                    type="date"
                    placeholder="Enter End Date"
                    value={formik.values.to_date}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className="filter-section-input"
                  ></input>

                  {formik.touched.to_date && formik.errors.to_date ? (
                    <div className="form-error">
                      {formik.errors.to_date}
                    </div>
                  ) : null}
                </div>
                {/* Select Report */}
                <div >
                  <Text
                    className="filter-section-label"
                  >
                    <span>
                      Select Report
                    </span>
                    <span className="text-red-500 font-inter font-small">
                      *
                    </span>
                  </Text>
                  <Select
                    name="report_type_id"
                    options={repotType?.map((resstate) => ({
                      label: resstate.name,
                      value: resstate.id,
                    }))}
                    classNamePrefix="filter-custom-select"

                    onChange={(selectedOption) => {
                      formik.setFieldValue(
                        "report_type_id",
                        selectedOption.value,
                      );
                      setpdfexportflag(false);
                      setReportTypeId(selectedOption.value);
                    }}
                    onBlur={formik.handleBlur}
                    placeholder="Select Report"
                    styles={{
                      control: (base) => ({
                        ...base,
                        width: "180px",
                      }),

                    }}
                  />
                  {formik.touched.report_type_id &&
                    formik.errors.report_type_id ? (
                    <div className="text-red-500 text-xs">
                      {formik.errors.report_type_id}
                    </div>
                  ) : null}
                </div>

                <div className="button-row ">
                  <button
                    type="submit"
                    id="dropdownDefaultButton"
                    className="btn-primary mt-4"
                    onClick={() => {
                      if (reportTypeId == 1) {
                        getHospitalBuissnessSummaryReport(
                          formik.values.from_date,
                          formik.values.to_date,
                        );
                      } else if (reportTypeId == 2) {
                        getHospitalBuissnessFeeDistributionSummaryReport(
                          formik.values.from_date,
                          formik.values.to_date,
                        );
                      } else if (reportTypeId == 3) {
                        getHospitalBuissnessPaymentTypeSummaryReport(
                          formik.values.from_date,
                          formik.values.to_date,
                        );
                      }
                      setpdfexportflag(true);
                    }}
                  >
                    Generate Report
                  </button>

                  {/* (hospitalBuissnessFeeDistributionSummaryReport.length > 0 || hospitalBuissnessPaymentTypeSummaryReport.length > 0) */}

                  {(reportTypeId == 2 || reportTypeId == 3) &&
                    pdfexportflag == true &&
                    (hospitalBuissnessFeeDistributionSummaryReport.length > 0 ||
                      hospitalBuissnessPaymentTypeSummaryReport.length > 0) ? (
                    <button
                      type="button"
                      id="dropdownDefaultButton"
                      className="btn-secondary mb-1.5"
                      onClick={() => {
                        if (reportTypeId === 2) {
                          DownloadPDF2();
                        } else if (reportTypeId === 3) {
                          DownloadPDF3();
                        }
                      }}
                    >
                      Export To PDF
                    </button>
                  ) : null}
                </div>
              </div>
            </div>
          </form>
          <ToastContainer />
          <hr className="w-full border" />
          <div className="h-[calc(100vh-215px)]">
            <div
              className="ag-theme-quartz "
              style={{ height: "100%", width: "100%", fontSize: "12px" }}
            >
              {hospitalBuissnessSummaryReport[0]?.total_fee != null &&
                reportTypeId == 1 && (
                  <AgGridReact
                    rowData={hospitalBuissnessSummaryReport.map(
                      (orders, index) => ({
                        ...orders,
                        sr: index + 1,
                      }),
                    )}
                    columnDefs={colDefsForReportId1}
                    pagination={true}
                    defaultColDef={ColDefaultVale}
                    suppressMenuHide={true}
                    suppressExcelExport={true}
                    gridOptions={
                      filterAppointment.length < 1 ? gridOptions2 : gridOptions
                    }
                  />
                )}

              {hospitalBuissnessFeeDistributionSummaryReport[0]?.total_fee !=
                null &&
                reportTypeId == 2 && (
                  <AgGridReact
                    rowData={hospitalBuissnessFeeDistributionSummaryReport.map(
                      (orders, index) => ({
                        ...orders,
                        sr: index + 1,
                      }),
                    )}
                    columnDefs={colDefsForReportId2}
                    pagination={true}
                    defaultColDef={ColDefaultVale}
                    suppressMenuHide={true}
                    suppressExcelExport={true}
                    gridOptions={
                      filterAppointment.length < 1 ? gridOptions2 : gridOptions
                    }
                  />
                )}

              {hospitalBuissnessPaymentTypeSummaryReport[0]?.total_fee !=
                null &&
                reportTypeId == 3 && (
                  <AgGridReact
                    rowData={hospitalBuissnessPaymentTypeSummaryReport.map(
                      (orders, index) => ({
                        ...orders,
                        sr: index + 1,
                      }),
                    )}
                    columnDefs={colDefsForReportId3}
                    pagination={true}
                    defaultColDef={ColDefaultVale}
                    suppressMenuHide={true}
                    suppressExcelExport={true}
                    gridOptions={
                      filterAppointment.length < 1 ? gridOptions2 : gridOptions
                    }
                  />
                )}
            </div>
          </div>
        </div>
      ) : (
        <AccessRightCard />
      )}
    </>
  );
};

export default RevenueSummaryReport;
